export type TFilterOption = { label: string; value: string };
export type TArticleFilterOptions = { categories: TFilterOption[]; topics: TFilterOption[] };

export const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null;

export const isFilterOption = (value: unknown): value is TFilterOption =>
    isRecord(value) && typeof value.label === 'string' && typeof value.value === 'string';

export const isArticleFilterOptions = (value: unknown): value is TArticleFilterOptions =>
    isRecord(value) && Array.isArray(value.categories) && value.categories.every(isFilterOption)
    && Array.isArray(value.topics) && value.topics.every(isFilterOption);

export const readArticleFilters = (search: string): URLSearchParams => {
    const source: URLSearchParams = new URLSearchParams(search);
    const filters: URLSearchParams = new URLSearchParams();
    ['category', 'tag'].forEach((key: string): void => {
        Array.from(new Set(source.getAll(key).filter((value: string): boolean => value.length > 0)))
            .forEach((value: string): void => filters.append(key, value));
    });
    return filters;
};

export const articleResultsUrl = (path: string, filters: URLSearchParams, page: number = 1): string => {
    const url: URL = new URL(path, window.location.origin);
    url.searchParams.delete('category');
    url.searchParams.delete('tag');
    filters.forEach((value: string, key: string): void => url.searchParams.append(key, value));
    url.searchParams.set('page', String(page));
    return `${url.pathname}${url.search}${url.hash}`;
};

export const clearArticleFiltersUrl = (path: string): string => {
    const url: URL = new URL(path, window.location.origin);
    url.pathname = url.pathname.replace(/\.\d+(?=\.html$|$)/, '');
    url.searchParams.delete('category');
    url.searchParams.delete('tag');
    url.searchParams.delete('page');
    return `${url.pathname}${url.search}${url.hash}`;
};
